const UserActionTypes = {
  AUTHENTICATE_REQUESTED: 'AUTHENTICATE_REQUESTED',
  AUTHENTICATE_SUCCEEDED: 'AUTHENTICATE_SUCCEEDED',
  AUTHENTICATE_FAILED: 'AUTHENTICATE_FAILED',
  SET_USERS: 'SET_USERS',
  LOGOUT_USER: 'LOGOUT_USER',
};

export default UserActionTypes;
